import React, { useState } from 'react';
import { Link, Modal } from 'elmo-elements';
import './ElearningResumeModal.scss';

interface ElearningResumeModalProps {
  setCurrentFrameId: (frameId: string) => void;
  elearningName: string | undefined;
}

const ElearningResumeModal = ({
  setCurrentFrameId,
  elearningName,
}: ElearningResumeModalProps) => {
  const [showResumeModal, setShowResumeModal] = useState(true);

  return (
    <Modal
      id="resume-elearning-modal"
      type="medium"
      isOpened={showResumeModal}
      closeModal={() => setShowResumeModal(false)}
      title="Welcome Back"
      closeLabel="Close"
    >
      <h3>
        <i> Welcome back to {elearningName}</i>
      </h3>
      <h3>What would you like to do? </h3>
      <p>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <Link
          url="#"
          onClick={(e) => {
            e.preventDefault();
            setShowResumeModal(false);
          }}
        >
          Continue from your last viewed slide
        </Link>
      </p>
      <p>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <Link
          url="#"
          onClick={(e) => {
            e.preventDefault();
            setCurrentFrameId('');
            setShowResumeModal(false);
          }}
        >
          Restart the course
        </Link>
      </p>
    </Modal>
  );
};

export function useResumeElearning(
  setCurrentFrameId: (frameId: string) => void,
  elearningName: string | undefined,
  showResumeModal: boolean,
): JSX.Element | null {
  if (!showResumeModal) {
    return null;
  }

  return (
    <ElearningResumeModal
      setCurrentFrameId={setCurrentFrameId}
      elearningName={elearningName}
    />
  );
}
